// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrreportspg-inline-1 {
  margin-bottom: 14px;
}

.hrreportspg-inline-2 {
  display: grid;
  gap: 10px;
}

.hrreportspg-inline-3 {
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr;
  gap: 10px;
}

.hrreportspg-inline-4 {
  display: flex;
  justify-content: flex-end;
}

.hrreportspg-inline-5 {
  padding: 0;
  overflow-x: auto;
}

.hrreportspg-inline-6 {
  padding: 18px;
}

.hrreportspg-inline-7 {
  text-align: center;
  padding: 22px;
  color: #94a3b8;
}

.hrreportspg-inline-8 {
  font-family: monospace;
  font-size: 11px;
}

.hrreportspg-inline-9 {
  font-weight: 600;
}

.hrreportspg-inline-10 {
  max-width: 240px;
}

.hrreportspg-inline-11 {
  display: flex;
  gap: 6px;
}

.hrreportspg-inline-12 {
  max-width: 760px;
}

.hrreportspg-inline-13 {
  max-height: 70vh;
  overflow: auto;
}

.hrreportspg-inline-14 {
  margin-bottom: 10px;
}

.hrreportspg-inline-15 {
  border: 1px solid #fee2e2;
  background: #fef2f2;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 12px;
}

.hrreportspg-inline-16 {
  font-weight: 600;
  margin-bottom: 8px;
}

.hrreportspg-inline-17 {
  margin-top: 8px;
}

.hrreportspg-inline-18 {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}

.hrreportspg-inline-19 {
  font-weight: 600;
  margin-bottom: 8px;
}

.hrreportspg-inline-20 {
  color: #94a3b8;
}

.hrreportspg-inline-21 {
  border-bottom: 1px solid #f1f5f9;
  padding: 8px 0;
}

.hrreportspg-inline-22 {
  font-size: 12px;
  font-weight: 600;
}

.hrreportspg-inline-23 {
  font-size: 12px;
  color: #64748b;
}

.hrreportspg-inline-24 {
  font-size: 11px;
  color: #94a3b8;
}

.hrreportspg-inline-25 {
  position: fixed;
  inset: 0;
  background: rgba(2,6,23,.45);
  display: grid;
  place-items: center;
  z-index: 3000;
}

.hrreportspg-inline-26 {
  width: min(1000px, 94vw);
  height: min(88vh, 760px);
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.hrreportspg-inline-27 {
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hrreportspg-inline-28 {
  font-weight: 700;
}

.hrreportspg-inline-29 {
  width: 100%;
  height: 100%;
  border: 0;
}

.hrreportspg-dyn-1 {
  background: var(--hrreportspg-1-background);
  border: var(--hrreportspg-1-border);
  color: var(--hrreportspg-1-color);
}


.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* பின்னாடி மங்கலாக தெரிய */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* எல்லாவற்றுக்கும் மேலே தெரிய */
}

.modal-card {
  background: white;
  width: 90%;
  max-width: 600px;
  border-radius: 12px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/HrReportsPg.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,mCAAmC;EACnC,iCAAiC;AACnC;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,2BAA2B;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,gCAAgC;AACjD;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".hrreportspg-inline-1 {\n  margin-bottom: 14px;\n}\n\n.hrreportspg-inline-2 {\n  display: grid;\n  gap: 10px;\n}\n\n.hrreportspg-inline-3 {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr 1fr;\n  gap: 10px;\n}\n\n.hrreportspg-inline-4 {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.hrreportspg-inline-5 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.hrreportspg-inline-6 {\n  padding: 18px;\n}\n\n.hrreportspg-inline-7 {\n  text-align: center;\n  padding: 22px;\n  color: #94a3b8;\n}\n\n.hrreportspg-inline-8 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.hrreportspg-inline-9 {\n  font-weight: 600;\n}\n\n.hrreportspg-inline-10 {\n  max-width: 240px;\n}\n\n.hrreportspg-inline-11 {\n  display: flex;\n  gap: 6px;\n}\n\n.hrreportspg-inline-12 {\n  max-width: 760px;\n}\n\n.hrreportspg-inline-13 {\n  max-height: 70vh;\n  overflow: auto;\n}\n\n.hrreportspg-inline-14 {\n  margin-bottom: 10px;\n}\n\n.hrreportspg-inline-15 {\n  border: 1px solid #fee2e2;\n  background: #fef2f2;\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 12px;\n}\n\n.hrreportspg-inline-16 {\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.hrreportspg-inline-17 {\n  margin-top: 8px;\n}\n\n.hrreportspg-inline-18 {\n  margin-top: 8px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.hrreportspg-inline-19 {\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.hrreportspg-inline-20 {\n  color: #94a3b8;\n}\n\n.hrreportspg-inline-21 {\n  border-bottom: 1px solid #f1f5f9;\n  padding: 8px 0;\n}\n\n.hrreportspg-inline-22 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.hrreportspg-inline-23 {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.hrreportspg-inline-24 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.hrreportspg-inline-25 {\n  position: fixed;\n  inset: 0;\n  background: rgba(2,6,23,.45);\n  display: grid;\n  place-items: center;\n  z-index: 3000;\n}\n\n.hrreportspg-inline-26 {\n  width: min(1000px, 94vw);\n  height: min(88vh, 760px);\n  background: #fff;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n}\n\n.hrreportspg-inline-27 {\n  padding: 10px 12px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.hrreportspg-inline-28 {\n  font-weight: 700;\n}\n\n.hrreportspg-inline-29 {\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.hrreportspg-dyn-1 {\n  background: var(--hrreportspg-1-background);\n  border: var(--hrreportspg-1-border);\n  color: var(--hrreportspg-1-color);\n}\n\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* பின்னாடி மங்கலாக தெரிய */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999; /* எல்லாவற்றுக்கும் மேலே தெரிய */\n}\n\n.modal-card {\n  background: white;\n  width: 90%;\n  max-width: 600px;\n  border-radius: 12px;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
